import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=0c034249"
var script = {}
import style0 from "./Index.vue?vue&type=style&index=0&id=0c034249&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports